export default __webpack_public_path__ + "static/media/No3Open.16471716.jpg";